export const posts = [
  {
    slug: "leber-schluessel-zur-gesundheit",
    category: "Gesundheit",
    read: "5 Min",
    date: "15. März 2024",
    dateISO: "2024-03-15",
    title: "Warum die Leber der Schlüssel zu deiner Gesundheit ist",
    excerpt:
      "Die Leber ist eines der am meisten unterschätzten Organe. Wie du sie sanft unterstützen kannst — ohne Extreme.",
    img: "https://images.unsplash.com/photo-1477332552946-cfb384aeaf1c?auto=format&fit=crop&w=1600&q=80",
    chip: "bg-sage-400 text-bone-50",
    tone: "sage",
    content: [
      { type: "p", text: "Die Leber arbeitet täglich auf Hochtouren — sie filtert, entgiftet und speichert. Und doch wird sie in vielen Gesundheitsansätzen kaum beachtet." },
      { type: "h", text: "Warum Anthony William sie ins Zentrum stellt" },
      { type: "p", text: "Im Medical-Medium-Ansatz ist die Leber der Motor der Gesundheit. Viele chronische Symptome, die scheinbar nichts miteinander zu tun haben, können durch eine überlastete Leber zusammenhängen — Müdigkeit, Hautprobleme, hormonelle Themen." },
      { type: "h", text: "Drei sanfte Schritte für den Alltag" },
      { type: "list", items: [
        "Morgens auf leeren Magen 500 ml Selleriesaft.",
        "Zitronenwasser als sanftes Ritual zum Start in den Tag.",
        "Schwere Fette am Morgen reduzieren, damit die Leber entlasten kann.",
      ]},
      { type: "p", text: "Kein Dogma, keine Extreme — nur kleine Gewohnheiten, die einen spürbaren Unterschied machen." },
    ],
  },
  {
    slug: "finanzielle-klarheit-erste-schritte",
    category: "Finanzen",
    read: "7 Min",
    date: "10. März 2024",
    dateISO: "2024-03-10",
    title: "Der Start in die finanzielle Klarheit: Die ersten Schritte",
    excerpt:
      "Finanzielle Planung muss nicht kompliziert sein. Drei praktische Schritte, mit denen du heute beginnst.",
    img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1600&q=80",
    chip: "bg-clay-400 text-bone-50",
    tone: "clay",
    content: [
      { type: "p", text: `„Ich kümmere mich später drum." — der Satz, der Finanzen oft zu einem dauerhaften Später macht. Dabei sind die ersten Schritte erstaunlich einfach.` },
      { type: "h", text: "Schritt 1 — Einnahmen & Ausgaben sichtbar machen" },
      { type: "p", text: "Nicht optimieren, nicht bewerten. Nur drei Monate ehrlich beobachten. Das allein schafft Klarheit." },
      { type: "h", text: "Schritt 2 — Reserven aufbauen" },
      { type: "p", text: "Ein Notgroschen in Höhe von 2–3 Monatsausgaben ist der ruhige Boden, auf dem alles andere steht." },
      { type: "h", text: "Schritt 3 — Absicherung prüfen" },
      { type: "p", text: "Was passiert, wenn du längere Zeit ausfällst? Berufsunfähigkeit und Haftpflicht sind die Basis — alles andere kommt später." },
    ],
  },
  {
    slug: "frische-saefte-mehr-als-trend",
    category: "Gesundheit",
    read: "4 Min",
    date: "5. März 2024",
    dateISO: "2024-03-05",
    title: "Frische Säfte: Mehr als nur ein Trend",
    excerpt:
      "Warum frisch gepresste Säfte so besonders sind — und wie du sie ohne Aufwand in deinen Alltag integrierst.",
    img: "https://images.pexels.com/photos/4443440/pexels-photo-4443440.jpeg?auto=compress&cs=tinysrgb&w=1600",
    chip: "bg-sage-400 text-bone-50",
    tone: "sage",
    content: [
      { type: "p", text: "Frisch gepresste Säfte liefern Nährstoffe in einer Form, die der Körper sofort aufnehmen kann — ohne Verdauungsaufwand." },
      { type: "h", text: "Mein Favorit: Sellerie-Gurke-Zitrone" },
      { type: "list", items: [
        "1 großer Selleriestaude",
        "½ Gurke",
        "½ Zitrone",
        "Optional: ein Stück Ingwer",
      ]},
      { type: "p", text: "Einfach pressen, 15 Minuten vor dem Frühstück trinken. Sanft, alltagstauglich — und überraschend wirksam." },
    ],
  },
  {
    slug: "altersvorsorge-verstehen",
    category: "Finanzen",
    read: "8 Min",
    date: "1. März 2024",
    dateISO: "2024-03-01",
    title: "Altersvorsorge verstehen: Was du wirklich wissen musst",
    excerpt:
      "Altersvorsorge ist komplex — muss aber nicht verwirrend sein. Die wichtigsten Grundlagen, klar erklärt.",
    img: "https://images.unsplash.com/photo-1579621970588-a35d0e7ab9b6?auto=format&fit=crop&w=1600&q=80",
    chip: "bg-clay-400 text-bone-50",
    tone: "clay",
    content: [
      { type: "p", text: "Die gesetzliche Rente ist eine Grundversorgung — selten mehr. Wer später den gleichen Lebensstandard möchte, kommt an privater Vorsorge kaum vorbei." },
      { type: "h", text: "Die drei Säulen" },
      { type: "list", items: [
        "Gesetzliche Rente (Säule 1)",
        "Betriebliche Altersvorsorge (Säule 2)",
        "Private Vorsorge: Rürup, Riester, ETFs, Immobilien (Säule 3)",
      ]},
      { type: "p", text: "Welche Kombination zu dir passt, hängt von Alter, Einkommen und Lebensphase ab. Genau das schauen wir im Erstgespräch gemeinsam an." },
    ],
  },
  {
    slug: "balance-im-alltag",
    category: "Lifestyle",
    read: "6 Min",
    date: "25. Februar 2024",
    dateISO: "2024-02-25",
    title: "Balance im Alltag: Gesundheit und Finanzen vereinen",
    excerpt:
      "Warum diese beiden Bereiche zusammengehören — und wie du sie in deinen Alltag integrierst, ohne dich zu verlieren.",
    img: "https://images.unsplash.com/photo-1535914254981-b5012eebbd15?auto=format&fit=crop&w=1600&q=80",
    chip: "bg-honey-400 text-ink-900",
    tone: "honey",
    content: [
      { type: "p", text: "Körper und Finanzen sind zwei Systeme, die dasselbe wollen: Stabilität. Wer sein Nervensystem reguliert, trifft auch finanziell ruhigere Entscheidungen." },
      { type: "h", text: "Rituale, die beides verbinden" },
      { type: "list", items: [
        "Morgens 10 Minuten ohne Handy — nur Wasser und Atmen.",
        "Einmal im Monat ein Finanz-Check-in (30 Minuten reichen).",
        "Abends drei Dinge aufschreiben, die gut waren.",
      ]},
      { type: "p", text: "Es geht nicht um Perfektion, sondern um Wiederholung." },
    ],
  },
  {
    slug: "wellness-home-office",
    category: "Lifestyle",
    read: "5 Min",
    date: "20. Februar 2024",
    dateISO: "2024-02-20",
    title: "Wellness im Home Office: Produktiv und gesund arbeiten",
    excerpt:
      "Kleine Rituale, die dich im Home Office wach, fokussiert und entspannt halten.",
    img: "https://images.unsplash.com/photo-1768659347532-74d3b1efb0ae?auto=format&fit=crop&w=1600&q=80",
    chip: "bg-honey-400 text-ink-900",
    tone: "honey",
    content: [
      { type: "p", text: "Home Office kann ein Geschenk sein — oder ein stiller Energieräuber. Der Unterschied liegt in den Ritualen." },
      { type: "h", text: "Meine drei Grundregeln" },
      { type: "list", items: [
        "Ein richtiger Start: Dusche, Anziehen, 5 Minuten an die frische Luft.",
        "Bewusste Mittagspause ohne Bildschirm.",
        "Ein klarer Feierabend: Laptop zu, Schreibtisch aufräumen.",
      ]},
      { type: "p", text: "Klein anfangen. Dranbleiben. Es verändert mehr, als man denkt." },
    ],
  },
];

export const getPostBySlug = (slug) => posts.find((p) => p.slug === slug);
